'use strict'

import css from './category-selection.styles.scss'
import template from './category-selection.template.pug'

class CategorySelectionController {
  constructor(CompanyService) {
    'ngInject'
    Object.assign(this, { CompanyService })
  }

  select() {
    this.onSelect({ categoryCode: this.categoryCode })
  }
}

export const umsCategorySelection = {
  controller: CategorySelectionController,
  template: template({ css }),
  bindings: {
    categories: '<',
    onSelect: '&',
  },
}



// WEBPACK FOOTER //
// ./app/orders/components/category-selection/category-selection.component.js